/* eslint-disable max-len */
import React from 'react';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames/bind';

import careersData from '../../public/careersData.json';
import { generateRandomKey } from '../../utils';

import sitemapClasses from '../../css/sitemap.module.css';
import styles from './JobsByIndustry.module.css';

let cx = classNames.bind(styles);

const JobsByIndustry = (props) => {
  const containerClass =
    props && props.isHomePage
      ? `section ${styles['industries-sec']}`
      : `section ${styles['industries-sec']} ${sitemapClasses['siteMapTopLevelCareer']}`;
  return (
    <section className={containerClass}>
      <div className={props.noSpacings ? '' : 'container'}>
        {props.headerTitle && props.headerTitle.length ? (
          <div className="col-lg-12 main_inner">
            <h2 className="brandonH2 sec-head">{props.headerTitle}</h2>
          </div>
        ) : (
          <div className={classNames('col-lg-12', props.noSpacings && 'px-0')}>
            {props.title ||
              (props.isExplorePage ? (
                <h2 className="sectionTitle brandonH1">Jobs By Industry</h2>
              ) : (
                <h2 className="brandonH2 mt-3">Jobs By Industry</h2>
              ))}
          </div>
        )}
        <div
          className={classNames(`${styles['sec-body']} col-lg-12`, {
            'z-px-0 z-px-md-15': props.noSpacings,
          })}
        >
          <ul className="listWithIcons p-0 d-flex flex-row flex-lg-column flex-wrap">
            {(props.industries || careersData.careers).map((industry) => (
              <li key={generateRandomKey()}>
                <a href={industry.link}>
                  <span className={`${cx(industry.class.split(' '))} ${industry.class}`}></span>
                  <span className="list-link industry-title">{`${industry.title}`}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default JobsByIndustry;
